import { render, staticRenderFns } from "./campaign-10-20-heading.vue?vue&type=template&id=0fdfc837&scoped=true&"
import script from "./campaign-10-20-heading.vue?vue&type=script&lang=js&"
export * from "./campaign-10-20-heading.vue?vue&type=script&lang=js&"
import style0 from "./campaign-10-20-heading.vue?vue&type=style&index=0&id=0fdfc837&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdfc837",
  null
  
)

export default component.exports